var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.4,
    height: 21.453,
    viewBox: "0 0 21.4 21.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1313",
    "data-name": "Rectangle 1313",
    width: 21.4,
    height: 21.453,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2635",
    "data-name": "Group 2635",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2634",
    "data-name": "Group 2634",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3778",
    "data-name": "Path 3778",
    d: "M0,21.452l1.538-5.738a10.618,10.618,0,1,1,4.23,4.193Zm6.055-3.7.363.216a8.62,8.62,0,1,0-2.95-2.923l.223.366-.859,3.2Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3779",
    "data-name": "Path 3779",
    d: "M18.434,15.806a1.781,1.781,0,0,0-1.518-.342c-.394.161-.646.779-.9,1.093a.377.377,0,0,1-.489.106,6.874,6.874,0,0,1-3.43-2.938.42.42,0,0,1,.053-.574,2.327,2.327,0,0,0,.623-1.011,2.212,2.212,0,0,0-.279-1.2,2.834,2.834,0,0,0-.884-1.332,1.212,1.212,0,0,0-1.315.2,2.671,2.671,0,0,0-.926,2.115,3,3,0,0,0,.083.671,5.545,5.545,0,0,0,.645,1.484,11.788,11.788,0,0,0,.672,1.023,10.39,10.39,0,0,0,2.916,2.707,8.817,8.817,0,0,0,1.818.865,4.036,4.036,0,0,0,2.117.335,2.565,2.565,0,0,0,1.92-1.428,1.244,1.244,0,0,0,.089-.729c-.11-.5-.789-.8-1.2-1.043",
    transform: "translate(-3.689 -3.736)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.7d187a5ccf5e5769f61ca6b031c2eb6a.svg";
export { ForwardRef as ReactComponent };